export default "__VITE_ASSET__c122924e__"